export const addHost = function (value, host = '') {
    if (/http/.test(value)) {
        return value;
    }
    if (!value || !host) {
        return '';
    }
    return host + value;
};
